import { Text, View } from '@react-pdf/renderer'

import { styles } from '../styles/styles'
import type { WorkflowReportDataI } from '../types/types'
import { formatReportTimestamp } from '../utils/utils'
import { SectionTitle } from './SectionTitle'

interface WorkflowIProps {
  timeZone?: string | null
  workflowReportData?: WorkflowReportDataI
  workflowUserNameMap: Map<string, string>
}

export const Workflow = ({
  timeZone,
  workflowReportData,
  workflowUserNameMap,
}: WorkflowIProps) => {
  if (!workflowReportData?.hasWorkflows) {
    return null
  }

  const workflow =
    workflowReportData.assignedWorkflow ??
    workflowReportData.pendingWorkflowFull
  const stepMap = new Map(workflow?.steps.map((step) => [step.id, step]) ?? [])
  const workflowActions = workflowReportData.workflowActions

  return (
    <View style={styles.section}>
      <SectionTitle icon='workflow' title='Workflow' />
      {workflowActions.length === 0 ? (
        <Text style={styles.workflowEmptyText}>
          No workflow actions were completed before resolution.
        </Text>
      ) : (
        workflowActions.map((action) => (
          <View key={action.id} style={styles.workflowRow} wrap={false}>
            <Text style={styles.workflowMeta}>
              {formatReportTimestamp(action.actionTimestamp, timeZone)} |{' '}
              {workflowUserNameMap.get(action.userId) ?? 'Unknown user'}
            </Text>
            <View style={styles.workflowQuestionRow}>
              <Text style={styles.workflowQuestion}>
                {stepMap.get(action.sourceNodeId)?.prompt ??
                  action.sourceNodeId}
              </Text>
              <Text style={styles.workflowAnswer}>{action.outcomeValue}</Text>
            </View>
          </View>
        ))
      )}
    </View>
  )
}
